
<div class="acess-view">        
    <mat-sidenav-container id="containerMenu" class="containerMenu">
        <mat-sidenav #sidenav mode="side" opened="true" class="listaIntegracoes">            
            <mat-label class="titleInt">Tipos de Integração</mat-label>                                      
            <mat-list #integrations  cdkDropList cdkDropListConnectedTo="doneList" [cdkDropListData]="intData" class="example-list" (cdkDropListDropped)="drop($event)">
                <mat-list-item *ngFor="let int of intData" [value]="int.name" (click)="selectIntegration(int)" cdkDrag  [cdkDragDisabled]="!canInsert">                    
                    <div class="item-detail">
                      <ng-container *ngIf="!int.svg">
                        <mat-icon *cdkDragPreview class="dragPreview" mat-list-icon>{{int.iconInt}}</mat-icon>
                      </ng-container>
                      <ng-container *ngIf="int.svg">
                        <mat-icon *cdkDragPreview class="dragPreview" mat-list-icon [svgIcon]="int.iconInt"></mat-icon>
                      </ng-container>
                      <mat-icon *ngIf="!int.svg" mat-list-icon>{{int.iconInt}}</mat-icon>
                      <mat-icon *ngIf="int.svg" mat-list-icon [svgIcon]="int.iconInt"></mat-icon>
                      <div mat-line>{{int.name}}</div>                                        
                    </div>
                </mat-list-item>
            </mat-list>            
        </mat-sidenav>
        <mat-sidenav-content  class="contentContainer">
          <ngx-spinner bdColor = "rgba(255, 255, 255, 0.8)" [template]="ThemeService.getSpinnerTemplate()"  size = "medium" color = "#fff" type = "ball-clip-rotate-multiple" [fullScreen] = "false" [name]="'integrationsLoading'">
            <p style="font-size: 20px; color: white">Carregando Integrações...</p>
          </ngx-spinner>   
            <div class="done-container">
                <div id="doneList"
                  cdkDropList
                  [cdkDropListData]="intDataDone"
                  class="done-list"
                  (cdkDropListDropped)="drop($event)">                     
                  <div class="divDone" *ngFor="let item of intDataDone" >
                    <div class="arrow" *ngIf="item.index > 0">
                      <mat-icon >arrow_downward</mat-icon>                      
                    </div>
                    
                    <mat-icon *ngIf="!item.svg"  [color]="item.active=='S'?'primary':'warn'" [matTooltip]="item.active=='S'?'Etapa do Fluxo Ativa':'Etapa do Fluxo Inativa'" matTooltipClass="toolTip-request"  class="iconDone" mat-icon-button (click)="openSetupIntegration(item.sequence, item.name, item.nuInt)">{{item.iconInt}}</mat-icon>                 
                    <mat-icon *ngIf="item.svg"  [color]="item.active=='S'?'primary':'warn'" [matTooltip]="item.active=='S'?'Etapa do Fluxo Ativa':'Etapa do Fluxo Inativa'" matTooltipClass="toolTip-request"  class="iconDone" mat-icon-button (click)="openSetupIntegration(item.sequence, item.name, item.nuInt)" [svgIcon]="item.iconInt"></mat-icon>                 

                    <div mat-line class="lblDone">{{item.name}}</div>
                    <div mat-line class="lblName">({{item.sequence}} - {{item.nameIntegration}})</div>
                    <button mat-icon-button color="primary" (click)="removeIntegration(item.sequence)" aria-label="Example icon button with a home icon" [disabled]="!canDelete">
                      <mat-icon>remove_circle_outline</mat-icon>
                    </button>                    
                   </div>
                </div>
              </div>              
        </mat-sidenav-content>
      </mat-sidenav-container>     
    </div>